import { createFileRoute } from "@tanstack/react-router"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import {
  AnnMatchingNoAccess,
  AnnMatchingSettingsCard,
} from "~/components/settings/annMatching/AnnMatchingSettingsCard"
import useShowInternalFeatures from "~/hooks/useShowInternalFeatures"
import { useUser } from "~/providers/userProvider"

export const Route = createFileRoute("/_auth/settings/_layout/_internal/match-configuration")({
  component: RouteComponent,
})

function RouteComponent() {
  const { permissions } = useUser()
  const [showInternalFeatures] = useShowInternalFeatures()

  if (!permissions) return <LoadingOverlay />
  if (!showInternalFeatures)
    return <AnnMatchingNoAccess>No access to ANN config in demo environment.</AnnMatchingNoAccess>
  if (!permissions.isStaff)
    return (
      <AnnMatchingNoAccess>You do not have permission to access ANN config.</AnnMatchingNoAccess>
    )
  return <AnnMatchingSettingsCard />
}
